//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatDate } from '@/helpers/filters.js'
export default {
	props: ['resource'],
	computed: {
		hasCredits() {
			return this.$auth.loggedIn && this.$auth.user && this.$auth.user.user && this.$auth.user.user.credits > 0;
		},
		userCredits() {
			return this.$auth.user && this.$auth.user.user ? this.$auth.user.user.credits : 0;
		}
	},
	methods: {
		formatDate,
		start() {
			this.$store.commit('paywallStore/setView', 'active'); 
			this.$store.commit('modalStore/setModal', false);
			if (this.resource.in_recurring_subscription) {
				this.$store.commit('subscriptionsStore/setPaywallToSubscription', 'direct');
			} else {
				this.$store.commit('subscriptionsStore/setPaywallToSubscription', 'huren');
			}
			return;
		}
	}
}
